import { DEVICE, useWindowSizeChanged } from "@hooks/DeviceSize";
import CogsCard from "@shared-containers/CogsCard";
import CogsLocationBreakdownTable from "@shared-containers/CogsLocationBreakdown";
import ProductMixRevenueBreakdown from "@shared-containers/ProductMixRevenueBreakdown";
import {
  CustomCardWrapper,
  CustomCardWrapperDesktop,
  StyledRootBox,
  StyledRootBoxDesktop,
} from "./styles";

const CogsDashBoard = () => {
  const device = useWindowSizeChanged();
  const isDesktop = device === DEVICE.DESKTOP;

  return isDesktop ? (
    <>
      <CustomCardWrapperDesktop isSummary>
        <CogsCard />
      </CustomCardWrapperDesktop>
      <StyledRootBoxDesktop>
        <CustomCardWrapperDesktop>
          <CogsLocationBreakdownTable pagination={false} />
        </CustomCardWrapperDesktop>
        <CustomCardWrapperDesktop minHeight="600px">
          <ProductMixRevenueBreakdown />
        </CustomCardWrapperDesktop>
      </StyledRootBoxDesktop>
    </>
  ) : (
    <StyledRootBox>
      <CustomCardWrapper>
        <CogsCard />
      </CustomCardWrapper>
      <CustomCardWrapper>
        <CogsLocationBreakdownTable pagination={false} />
      </CustomCardWrapper>
      <CustomCardWrapper minHeight="600px">
        <ProductMixRevenueBreakdown />
      </CustomCardWrapper>
    </StyledRootBox>
  );
};

export default CogsDashBoard;
